import React from "react";
import KpiDashboard from "../utilities/kpi_dashboard/KpiDashboard";
import { useComplaintKpi } from "./store";

const ComplaintKpi = () => {
  const {
    complaintKpiData,
    fetchComplaintKpiData,
    complaintKpiDataLoading,
    complaintKpiFilterData,
    complaintKpiFilterDataLoading,
    fetchComplaintKpiFilter,
  } = useComplaintKpi();

  return (
    <KpiDashboard
      title="Complaint KPI Dashboard"
      fetchData={fetchComplaintKpiData}
      fetchFilterData={fetchComplaintKpiFilter}
      filterDataLoading={complaintKpiFilterDataLoading}
      filterData={complaintKpiFilterData}
      headers={complaintKpiData.headers}
      totalRowCount={complaintKpiData.total_row_count}
      rowsData={complaintKpiData.rows_data}
      loading={complaintKpiDataLoading}
    />
  );
};

export default ComplaintKpi;
